import React, { useState } from 'react';
import './ButtonSidebar.css'; // Asegúrate de tener este archivo CSS para estilos
import share2SVG from '../Iconos/share2.svg';
import relojIMG from '../Imagenes/reloj.png';
import { useHistory } from 'react-router-dom';

interface ButtonSidebarProps {
    onSaveDraft: () => void;
}

const ButtonSidebar3: React.FC<ButtonSidebarProps> = ({ onSaveDraft }) => {
    const [hoveredButton, setHoveredButton] = useState<string | null>(null);
    const history = useHistory();

    const handleMouseEnter = (buttonName: string) => {
        setHoveredButton(buttonName);
    };

    const handleMouseLeave = () => {
        setHoveredButton(null);
    };
    const handleNextClick = () => {
        // Aquí pones la lógica para ir al paso anterior
        history.push('/Drafts');
      };
    
    return (
        <div className='sidebar4'>
            <div className="sidebar-buttons">
                <button className="sidebar-button"
                    onClick={onSaveDraft}
                    onMouseEnter={() => handleMouseEnter('share')}
                    onMouseLeave={handleMouseLeave}>
                    <img src={share2SVG} alt="Guardar borrador" />
                    {hoveredButton === 'share' && <span className="button-label">Guardar borrador</span>}
                </button>
                <button className="sidebar-button" onClick={handleNextClick}
                    onMouseEnter={() => handleMouseEnter('reloj')}
                    onMouseLeave={handleMouseLeave}>
                    <img src={relojIMG} alt="Ver borradores" />
                    {hoveredButton === 'reloj' && <span className="button-label">Borradores</span>}
                </button>
            </div>
        </div>
    );
};

export default ButtonSidebar3;
